export interface IdeoToastProgress
{
    remaining: number;
    offset: number;
}

export function resolveIdeoToastProgress(duration?: number, deadline?: number, now = Date.now()): IdeoToastProgress | null
{
    if (typeof duration !== 'number' || !Number.isFinite(duration) || duration <= 0)
        return null;

    if (typeof deadline !== 'number' || !Number.isFinite(deadline))
        return null;

    const remaining = Math.min(duration, Math.max(0, deadline - now));

    return {
        remaining,
        offset: 1 - remaining / duration
    };
}
